// /glossary find box: filters the server-rendered term list in place (GlossaryPage.svelte's filter):
// a term stays when its name, definition or an alias contains the query, case-insensitively.
// Letter headings, A-Z links and the count follow the visible terms. Without JS every term stays listed.
;(() => {
  const root = document.querySelector('[data-glossary]')
  const input = root && root.querySelector('[data-glossary-find]')
  if (root && input) {
    const rows = Array.from(root.querySelectorAll('li[data-glossary-text]'))
    const groups = Array.from(root.querySelectorAll('[data-glossary-group]'))
    const count = root.querySelector('[data-glossary-count]')
    const countLine = count && count.closest('[data-glossary-count-line]')
    const az = root.querySelector('[data-glossary-az]')
    const empty = root.querySelector('[data-glossary-empty]')
    const apply = () => {
      const q = input.value.trim().toLowerCase()
      let shown = 0
      for (const row of rows) {
        const hit = !q || row.dataset.glossaryText.includes(q)
        row.hidden = !hit
        if (hit) shown++
      }
      const letters = []
      for (const list of groups) {
        const any = list.querySelector('li:not([hidden])') !== null
        list.hidden = !any
        const heading = list.previousElementSibling
        if (heading) heading.hidden = !any
        if (any) letters.push(list.dataset.glossaryGroup)
      }
      if (count) count.textContent = String(shown)
      if (countLine) countLine.hidden = shown === 0
      if (az) {
        az.hidden = shown === 0 || letters.length < 2
        for (const a of az.querySelectorAll('[data-glossary-letter]')) a.hidden = !letters.includes(a.dataset.glossaryLetter)
      }
      if (empty) empty.hidden = shown !== 0
    }
    input.addEventListener('input', apply)
    if (input.value) apply()
  }
})()
